import { useEffect, useState } from 'react';
import workspaceAPI from '../../services/workspaceAPI';

const WorkspaceNotifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    workspaceAPI
      .getNotifications()
      .then((res) => setNotifications(res.data.notifications || []))
      .catch((err) => setError(err.response?.data?.message || 'Failed to load notifications'));
  }, []);

  if (error) return <p className="workspace-alert error">{error}</p>;

  return (
    <div>
      <h1 className="workspace-page-title">Notifications & reports</h1>
      <p className="workspace-page-subtitle">Company alerts, booking updates, and system messages.</p>
      <div className="workspace-grid">
        {notifications.map((n) => (
          <div key={n._id} className="workspace-card">
            <h3 style={{ textTransform: 'none', color: '#0f172a' }}>{n.title || n.type || 'Notification'}</h3>
            <p style={{ margin: 0, fontSize: '0.9rem' }}>{n.message || n.body || '—'}</p>
            <small style={{ color: '#64748b' }}>{new Date(n.createdAt).toLocaleString()}</small>
          </div>
        ))}
      </div>
      {notifications.length === 0 && <p>No company notifications yet.</p>}
    </div>
  );
};

export default WorkspaceNotifications;
